const ListTable = require('app/ui/list/Table');
const GraphQLMutation = require('app/graphql/Mutation');


class ConfigTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'view': null,
            'length': 100,
            'productShowBaseUrl': window.App.get('productShowBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
        this.onSubmitMainForm = this.onSubmitMainForm.bind(this);
        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.view = this.settings.view;
        if(!this.view){
            window.notify("Missing view parameter","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
    }

    buildTab(){

        this.$tableContainer = $('<div/>')
        .addClass('product-price-config-list-container');

        this.$filterForm = this.view.buildFilterForm(this.onSubmitFilterForm);
        this.$filterByNumber = $('input[name="number"]',this.$filterForm);
        this.$filterByReference = $('input[name="reference"]',this.$filterForm);
        this.$filterByRange = $('select[name="range"]',this.$filterForm);
        this.$filterBySupplier = $('select[name="supplier"]',this.$filterForm);

        console.log("buildTab",this);

        this.$listContainer = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-9 p-2')
            .append(
                $('<div/>')
                .addClass('white-box')
                .append(this.$tableContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-3 p-2')
            .append(
                $('<div/>')
                .addClass('white-box')
                .append(
                    $('<h3/>')
                    .addClass('box-title')
                    .append(window.translate('app.product.search.label'))
                )
                .append(this.$filterForm)
            )
        )
        .hide();

        this.$content = $('<div/>')
        .append(
            $('<div/>')
            .addClass('white-box d-flex justify-content-center')
            .append(this.buildMainForm())
        )
        .append(this.$listContainer);

        this.$container
        .html('')
        .append(this.$content);

        this.onDOMReady();
    }


    buildMainForm(){
        this.$mainForm = $('<form/>')
        .addClass('product-price-update-config-date-form')
        .append(
            $('<h3/>')
            .append(window.translate('app.product.price.new.tabs.config.form.title'))
        );

        let min = moment().add(1, 'day').format('YYYY-MM-DD');

        this.$inputDate = $('<input/>')
        .attr("type","date")
        .attr("name","date")
        .attr("id","date")
        .addClass("form-control")
        .attr('min',min)
        .attr('required','required');

        this.$mainForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(this.$inputDate)
        )

        this.$inputDate.on("change",this.onSubmitMainForm);
        this.$mainForm.on("submit",this.onSubmitMainForm);

        return this.$mainForm;
    }

    drawEmptyList(){
        this.$tableContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('alert alert-info')
            .append(window.translate('app.product.price.new.tabs.config.list.empty'))
        );
    }

    onSubmitFilterForm(event){
        event.preventDefault();
        event.stopPropagation();

        if(!this.$inputDate.val()){
            this.drawEmptyList();
            return;
        }
        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }

    onSubmitMainForm(event){
        event.preventDefault();
        event.stopPropagation();

        if(this.$inputDate.val()){
            this.$listContainer.show();
            this.initializeListTable();
        }
    }

    buildRowId(item){
        return 'product'+item.id;
    }

    buildGraphQLParameters(){
        let filters = {
            'notStatus': 3,
        };

        if(this.$filterByNumber && this.$filterByNumber.val()){
            filters.number = this.$filterByNumber.val();
        }

        if(this.$filterByReference && this.$filterByReference.val()){
            filters.reference = '%'+this.$filterByReference.val()+'%';
        }

        if(this.$filterByRange && parseInt(this.$filterByRange.val())){
            filters.rootRange = parseInt(this.$filterByRange.val());
        }

        if(this.$filterBySupplier && parseInt(this.$filterBySupplier.val())){
            filters.supplier = parseInt(this.$filterBySupplier.val());
        }

        let orderBy = 'reference';
        let dir = "ASC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };

        return parameters;
    }

    initializeListTable(){
        if(this.listTableInitialized){
            return;
        }

        var self = this;

        let fields = [
            'id',
            'number',
            'reference',
            'price',
            'supplierPrice',
            'supplierPriceViewable',
            'supplier { id name rfa } ',
            'priceUpdatePendings { date }'
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped product-price-config-list',
            'id': 'list-products',
            'length': this.settings.length,
            'rowIdCallback': function(item){
                return self.buildRowId(item.node);
            },
            'graphQL': {
                'queryType': 'supplierProducts',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'product',
                    'label': window.translate('product.price.config.product.label'),
                    'class': 'product',
                    'render': function(item,index){
                        let $content = $("<div/>");

                        let urlShow = self.settings.productShowBaseUrl.replace('__ID__',item.node.id);
                        $content
                        .append(
                            $('<div/>')
                            .append(
                                $('<a/>')
                                .attr('href',urlShow)
                                .append(item.node.number)
                            )
                            .append(' - ')
                            .append(item.node.reference)
                        );

                        if(item.node.priceUpdatePendings && item.node.priceUpdatePendings.length > 0){
                            let priceUpdatePending = item.node.priceUpdatePendings[0];
                            let date = window.formatDate(priceUpdatePending.date,window.translate('momentDateFormat.fullDay'));
                            $content
                            .append(
                                $('<div/>')
                                .addClass('text-success')
                                .append(window.translate('product.price.config.pending.message',{'%date%':date}))
                            );
                        }
                        $content
                        .append(
                            $('<div/>')
                            .addClass('text-muted')
                            .append(window.translate('product.price.config.supplier.label'))
                            .append(' ')
                            .append(item.node.supplier.name)
                        );

                        return $content;
                    },
                },
                {
                    'name': 'supplierPrice',
                    'label': window.translate('product.price.config.supplierPrice.label'),
                    'class': 'product-price-config-supplierPrice',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let supplierPrice = item.node.supplierPrice;
                        if(!supplierPrice){
                            supplierPrice = '';
                        }
                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','supplierPrice')
                        .val(supplierPrice)
                        .on('change',function(){
                            self.onChangeSupplierPrice(item.node,$content);
                        });

                        let rfa = item.node.supplier.rfa ? item.node.supplier.rfa : 0;
                        let discount = item.node.supplierPrice- (item.node.supplierPrice * (rfa / 100));
                        let $discount = $('<small/>')
                        .addClass('discount text-muted')
                        .append(window.translate('discount'))
                        .append(' : ')
                        .append(window.formatFloat(discount)+' &euro;');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($discount)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'supplierPriceViewable',
                    'label': window.translate('product.price.config.supplierPriceViewable.label'),
                    'class': 'product-price-config-supplierPriceViewable',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let supplierPriceViewable = item.node.supplierPriceViewable;
                        if(!supplierPriceViewable){
                            supplierPriceViewable = '';
                        }
                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','supplierPriceViewable')
                        .val(supplierPriceViewable)
                        .on('change',function(){
                            self.onChangeSupplierPriceViewable(item.node,$content);
                        });

                        let margin = ((item.node.supplierPriceViewable - item.node.supplierPrice) / item.node.supplierPrice) * 100;
                        if(!isFinite(margin)){
                            margin = 0;
                        }
                        let $margin = $('<small/>')
                        .addClass('margin text-muted')
                        .append(window.translate('margin'))
                        .append(' : ')
                        .append(window.formatFloat(margin)+' %');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($margin)
                        );

                        return $content;
                    }
                },
                {
                    'name': 'price',
                    'label': window.translate('product.price.config.price.label'),
                    'class': 'product-price-config-price',
                    'render': function(item,index){
                        let $content = $('<div/>');

                        let price = item.node.price;
                        if(!price){
                            price = '';
                        }
                        let $input = $('<input/>')
                        .addClass("form-control form-control-sm")
                        .attr('type','text')
                        .attr('name','price')
                        .val(price)
                        .on('change',function(){
                            self.onChangePrice(item.node,$content);
                        });

                        if(!price){
                            price = item.node.price;
                        }
                        let margin = ((price - item.node.supplierPrice) / item.node.supplierPrice) * 100;
                        if(!isFinite(margin)){
                            margin = 0;
                        }
                        let $margin = $('<small/>')
                        .addClass('margin text-muted')
                        .append(window.translate('margin'))
                        .append(' : ')
                        .append(window.formatFloat(margin)+' %');

                        $content
                        .append($input)
                        .append(
                            $('<div/>')
                            .append($margin)
                        );

                        return $content;
                    }
                }
            ]
        })
    }

    onChangeSupplierPrice(item,$cellContent){
        let value = parseFloat($('input[name="supplierPrice"]',$cellContent).val());
        this.submitChange(item,'supplierPrice',value,$cellContent.parent());
    }

    onChangeSupplierPriceViewable(item,$cellContent){
        let value = parseFloat($('input[name="supplierPriceViewable"]',$cellContent).val());
        this.submitChange(item,'supplierPriceViewable',value,$cellContent.parent());
    }

    onChangePrice(item,$cellContent){
        let value = parseFloat($('input[name="price"]',$cellContent).val());
        this.submitChange(item,'price',value,$cellContent.parent());
    }

    onClickDelete(item){
        this.submitDelete(item);
    }

    setErrorCell($cell){
        $cell
        .addClass('bg-danger');
        $('.text-muted',$cell)
        .removeClass('text-muted')
        .addClass('text-white');
    }

    submitChange(item,field,value,$cell){
        var self = this;
        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'product': {
                'value': item.id,
                'type': 'Int!'
            },
            'date': {
                'value': this.$inputDate.val(),
                'type': "Date",
            }
        };
        if(field == 'status'){
            variables[field] = {
                'value': parseInt(value),
                'type': 'Int',
            };
        }else{
            variables[field] = {
                'value': parseFloat(value),
                'type': 'Float',
            };
        }
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitSupplierProductPriceUpdatePending",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,"success");
                    self.refresh(function(){
                        self.table.focus(self.buildRowId(item));
                    });
                }else{
                    self.setErrorCell($cell);
                }
            },
            'error': function(message, xhr){
                self.setErrorCell($cell);
            },
            'after': function(){
            }
        });
        mutation.execute();
    }
}

module.exports = ConfigTab;

